import { useState, useEffect } from "react";
import axiosInstance from "@/utils/axiosInstance";

export const useOrderData = () => {
  const [drivers, setDrivers] = useState<any[]>([]);
  const [partners, setPartners] = useState<any[]>([]);
  const [vehicles, setVehicles] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [driversResponse, partnersResponse, vehiclesResponse] = await Promise.all([
          axiosInstance.get("/drivers?start=1&end=10000"),
          axiosInstance.get("/referral-agents?start=1&end=10000"),
          axiosInstance.get("/vehicles?start=1&end=10000"),
        ]);

        setDrivers(driversResponse.data);
        setPartners(partnersResponse.data);
        setVehicles(vehiclesResponse.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return {
    drivers,
    partners,
    vehicles,
    loading,
  };
};